import {
  atomFamily,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { recoilPersist } from "recoil-persist";
import { IShoppingCart } from "../utils/constants/dynamic/article";
import { useXoraiaValue } from "./useXoraia";

const { persistAtom } = recoilPersist();

export const USE_WISHLIST = atomFamily<IShoppingCart, string>({
  key: "USE_WISHLIST",
  default: { carts: [] },
  effects_UNSTABLE: [persistAtom],
});

export function useWishlist() {
  const { businessId } = useXoraiaValue();
  const [wishlist, setWishlist] = useRecoilState(USE_WISHLIST(businessId));

  return { wishlist, setWishlist };
}

export function useWishlistUpdater() {
  const { businessId } = useXoraiaValue();

  return useSetRecoilState(USE_WISHLIST(businessId));
}

export function useWishlistValue() {
  const { businessId } = useXoraiaValue();

  return useRecoilValue(USE_WISHLIST(businessId));
}
